import { Timestamp } from 'firebase/firestore';

interface FirestoreTimestamp {
  seconds: number;
  nanoseconds: number;
}

type DateTimeInput = FirestoreTimestamp | Date | string | number | null | undefined;

export const formatDateTimeDisplay = (value: DateTimeInput): string => {
  if (!value) return '-';

  const date: Date =
    typeof value === 'object' && value !== null && 'seconds' in value
      ? new Date((value as FirestoreTimestamp).seconds * 1000)
      : new Date(value as string | number | Date);

  const pad = (n: number): string => String(n).padStart(2, '0');

  const year: number = date.getFullYear();
  const month: string = pad(date.getMonth() + 1);
  const day: string = pad(date.getDate());

  let hours: number = date.getHours();
  const minutes: string = pad(date.getMinutes());

  const ampm: string = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  if (hours === 0) hours = 12; // midnight or noon edge case
  const hoursStr: string = pad(hours);

  return `${year}-${month}-${day} ${hoursStr}:${minutes} ${ampm}`;
};

/**
 * Format Firestore Timestamp or compatible object for display in web (YYYY-MM-DD HH:mm)
 */
export function formatFirestoreTimestamp(ts: any, withTime: boolean = true): string {
  let date: Date | null = null;
  if (ts instanceof Timestamp) {
    date = ts.toDate();
  } else if (ts && typeof ts === 'object' && 'seconds' in ts && 'nanoseconds' in ts) {
    date = new Timestamp(ts.seconds, ts.nanoseconds).toDate();
  } else if (typeof ts === 'string') {
    const d = new Date(ts);
    date = isNaN(d.getTime()) ? null : d;
  }
  if (!date) return '';
  const pad = (n: number) => n.toString().padStart(2, '0');
  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  if (!withTime) return `${yyyy}-${mm}-${dd}`;
  const hh = pad(date.getHours());
  const min = pad(date.getMinutes());
  return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
}

/**
 * Convert a date picker selected value (Date|string|number) to Firestore Timestamp
 */
export function toFirestoreTimestamp(dateInput: Date | string | number): Timestamp | null {
  let date: Date | null = null;
  if (dateInput instanceof Date) {
    date = dateInput;
  } else if (typeof dateInput === 'string' || typeof dateInput === 'number') {
    const d = new Date(dateInput);
    date = isNaN(d.getTime()) ? null : d;
  }
  return date ? Timestamp.fromDate(date) : null;
}

export function toDateInputValue(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  if (!d || isNaN(d.getTime())) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  console.log('toDateInputValue', date, '=>', `${yyyy}-${mm}-${dd}`);
  return `${yyyy}-${mm}-${dd}`;
}